import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
  toggleMicrocentrifugeLid,
  toggleMicrocentrifugeControlsModal ,
  toggleMicrocentrifugeTooltipsControls,
  toggleMicrocentrifugeBalanceTubeModal,
  setMicrocentrifugeRPM,
  setMicrocentrifugeTime,
  ejectMicrocentrifugeTubes,
  ejectMicrocentrifugeRotors,
  checkMicrocentrifugeBalance,
  onMicrocentrifugeTubeDrop,
  onMicrocentrifugeInsertItem,
  onMicrocentrifugeRun,

  setSolutionInScene,
  setRotorAdaptersInScene,
  setSolutionOnRack,
  addTubeToIceBucket,
  setSolutionOnIce,

  setSolutionMixed,

  toggleLidMC, 
  openModalMC, 
  closeModalMC, 
  setModalViewMC, 
  setRPMMC, 
  setTimerMC, 
  animationPlaybackCompleteMC, 
  onDropSlotMC, 
  onRunCentrifugeMC, 
  onStopCentrifugeMC, 
  removeSlotItemsMC, 
  onItemDropCentrifugeMC,

} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].type,
    isOpen: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].isOpen,

    showControlsModal: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].showControlsModal,
    showTooltipControls: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].showTooltipControls,
    showBalanceTubeModal: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].showBalanceTubeModal,

    modalOpen: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].modalOpen,
    lidOpen: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].lidOpen,
    modalView: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].modalView,
    balanced: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].balanced,
    running: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].running,
    pulsing: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].pulsing,
    completed: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].completed,
    topViewData: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].topViewData,
    frontViewData: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].frontViewData,
    slots: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].slots,
  }
}

function mapDispatchToProps(dispatch) {
  return {

   toggleLidMC: (data)=>{
      dispatch(toggleLidMC(data))
   }, 
   openModalMC: (data)=>{
      dispatch(openModalMC(data))
   }, 
   closeModalMC: (data)=>{
      dispatch(closeModalMC(data))
   }, 
   setModalViewMC: (data)=>{
      dispatch(setModalViewMC(data))
   }, 
   setRPMMC: (data)=>{
      dispatch(setRPMMC(data))
   }, 
   setTimerMC: (data)=>{
      dispatch(setTimerMC(data))
   }, 
   animationPlaybackCompleteMC: (data)=>{
      dispatch(animationPlaybackCompleteMC(data))
   }, 
   onDropSlotMC: (data)=>{
      dispatch(onDropSlotMC(data))
   }, 
   onRunCentrifugeMC: (data)=>{
      dispatch(onRunCentrifugeMC(data))
   }, 
   onStopCentrifugeMC: (data)=>{
      dispatch(onStopCentrifugeMC(data))
   }, 
   removeSlotItemsMC: (data)=>{
      dispatch(removeSlotItemsMC(data))
   }, 
   onItemDropCentrifugeMC: (data)=>{
      dispatch(onItemDropCentrifugeMC(data))
   },
   
    toggleMicrocentrifugeLid: (data)=>{
       dispatch(toggleMicrocentrifugeLid(data))
    },
    toggleMicrocentrifugeControlsModal: (data)=>{
       dispatch(toggleMicrocentrifugeControlsModal(data))
    },
    toggleMicrocentrifugeBalanceTubeModal: (data)=>{
       dispatch(toggleMicrocentrifugeBalanceTubeModal(data))
    },
    toggleMicrocentrifugeTooltipsControls: (data)=>{
       dispatch(toggleMicrocentrifugeTooltipsControls(data))
    },
    setMicrocentrifugeRPM: (data)=>{
       dispatch(setMicrocentrifugeRPM(data))
    },
    setMicrocentrifugeTime: (data)=>{
       dispatch(setMicrocentrifugeTime(data))
    },
    ejectMicrocentrifugeTubes: (data)=>{
       dispatch(ejectMicrocentrifugeTubes(data))
    },
    ejectMicrocentrifugeRotors: (data)=>{
       dispatch(ejectMicrocentrifugeRotors(data))
    },
    onMicrocentrifugeTubeDrop: (data)=>{
       dispatch(onMicrocentrifugeTubeDrop(data))
    },
    checkMicrocentrifugeBalance: (data)=>{
       dispatch(checkMicrocentrifugeBalance(data))
    },
    onMicrocentrifugeInsertItem: (data)=>{
       dispatch(onMicrocentrifugeInsertItem(data))
    },
    onMicrocentrifugeRun: (data)=>{
       dispatch(onMicrocentrifugeRun(data))
    },
    setSolutionInScene: (data)=>{
       dispatch(setSolutionInScene(data))
    },
    setRotorAdaptersInScene: (data)=>{
       dispatch(setRotorAdaptersInScene(data))
    },
    setSolutionOnRack: (data) => {
      dispatch(setSolutionOnRack(data))
    },

    addTubeToIceBucket: (data) => {
      dispatch(addTubeToIceBucket(data))
    },
    setSolutionOnIce: (data) => {
      dispatch(setSolutionOnIce(data))
    },
    setSolutionMixed: (data) => {
      dispatch(setSolutionMixed(data))
    },
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
